import React from 'react';
import { BookOpen, BarChart2, Building2, Tag, ClipboardList, Wrench, TrendingUp, Target, ShieldCheck, Award } from 'lucide-react';
import ConfigCard from '../ConfigCard';

const QualificationsTab = ({ configData, cardProps }) => (
  <div className="space-y-6">
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <BookOpen className="w-5 h-5 text-gray-500" />
        Education Management
      </h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ConfigCard {...cardProps} title="Institution Types" icon={Building2}
          items={configData.institutionTypes}
          category="institutionTypes"
          fields={['description']}
        />
        <ConfigCard {...cardProps} title="Qualification Levels" icon={BarChart2}
          items={configData.qualificationLevels}
          category="qualificationLevels"
          fields={['level_number', 'country', 'description']}
        />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <ConfigCard {...cardProps} title="Fields of Study" icon={BookOpen}
          items={configData.fieldsOfStudy}
          category="fieldsOfStudy"
          fields={['category_display', 'description']}
        />
      </div>
    </div>

    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Award className="w-5 h-5 text-gray-500" />
        Professional Certificates
      </h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ConfigCard {...cardProps} title="Certification Authorities" icon={Building2}
          items={configData.certificationAuthorities}
          category="certificationAuthorities"
          fields={['short_name', 'country', 'is_government']}
        />
        <ConfigCard {...cardProps} title="Certification Categories" icon={Tag}
          items={configData.certificationCategories}
          category="certificationCategories"
          fields={['industry_focus_display', 'description']}
        />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <ConfigCard {...cardProps} title="Certification Templates" icon={ClipboardList}
          items={configData.certificationTemplates}
          category="certificationTemplates"
          fields={['issuing_authority_name', 'validity_period_months', 'is_renewable']}
        />
      </div>
    </div>

    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Wrench className="w-5 h-5 text-gray-500" />
        Skills &amp; Competencies
      </h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ConfigCard {...cardProps} title="Trade Categories" icon={Wrench}
          items={configData.tradeCategories}
          category="tradeCategories"
          fields={['description', 'industry_code']}
        />
        <ConfigCard {...cardProps} title="Competency Levels" icon={TrendingUp}
          items={configData.competencyLevels}
          category="competencyLevels"
          fields={['level_number', 'minimum_experience_months']}
        />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
        <ConfigCard {...cardProps} title="Skill Frameworks" icon={Target}
          items={configData.skillFrameworks}
          category="skillFrameworks"
          fields={['trade_category_name', 'competency_level_name', 'recertification_interval_months']}
        />
        <ConfigCard {...cardProps} title="Safety Certifications" icon={ShieldCheck}
          items={configData.safetyCertifications}
          category="safetyCertifications"
          fields={['authority', 'validity_years']}
        />
      </div>
    </div>
  </div>
);

export default QualificationsTab;
